export default {
	init() {

		/**
		Auto resize textarea
		 */
		$(document).on('input paste keyup', 'textarea.textarea-auto-height', function () {
			autoResizeTextarea(this)
		})
	
		// On page load, autoresize all matching textareas
		$('textarea.textarea-auto-height').each(function() {
			autoResizeTextarea(this)
		})



		function autoResizeTextarea(textarea) {
			textarea.style.height = 'auto' // reset height to shrink if needed
			textarea.style.height = textarea.scrollHeight + 'px'
		}

	}
}
